export enum TimerMode {
  Fixed = 'fixed',
  Evergreen = 'evergreen',
}

export enum TimerFinishStrategy {
  None = 'none',
  Hide = 'hide',
  Restart = 'restart',
  WaitOneDay = 'wait_one_day',
}

export interface TimerData {
  endDate: Date
  hash: TimerSettingsHash
}

export type TimerSettingsHash = `${TimerFinishStrategy}-${TimeUnit}-${number}`

export type TimeUnit = 'day' | 'hour' | 'minute' | 'second'
